// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commentform {
    border-radius: 13px !important;
    border: 2px solid #ebebeb !important;
    overflow: hidden !important;
}
.textblue{
    background-color: #0079ff !important;
    color: #fff;
}
/* .custum-card{
    position: absolute;
    width: 145px;
    height: 100px;
    transform: translate(1132px, 50px);
    z-index: 1;
} */
.done-top-job-text{
    font-size: 16px !important;
    color: #4a4a4a!important;
}
.gigclass {
/* font-size: 11px;
color: #4a4a4a!important; */
font-size: 11px;
    color: #656262 !important;
    font-weight: 300;
}
.text-areamini{
 height: 400px !important; 
 }
.comments {
    background-color: #0079FF;
    min-width: 240px;
    height: auto;
    max-width: 800px;
    color: white;
    padding: 8px;
    border-radius: 5px;
    /* word-wrap: break-word; */
    position: relative; /* Allow long words to wrap to the next line */
    overflow-wrap: break-word; /* For newer browsers */
    
  }
  .button-containers {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px;
  }
  
  .button-next {
    padding: 10px 20px;
    border: none;
    border-radius: 30px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.3s;
    display: flex;
    align-items: center;
  }
  
  .prev-button {
    background-color: #f1a631;
    color: white;
  }
  
  .next-button {
    background-color: #0042a6;
    color: white;
  }
  
  .prev-button:hover,
  .next-button:hover {
    background-color: #555;
    transform: scale(1.1);
  }
  
  .icon {
    margin: 0 10px;
  }
  /* custumcheckbox css */
  .custom-checkbox-icon {
    font-size: 24px;
    color: black;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
  }
  
  .custom-checkbox-icon.checked {
    background-color: green;
    color: white;
    border-radius: 50%;
    width: 25px; /* Adjust this value according to your design */
    height: 25px; /* Adjust this value according to your design */
    display: inline-block; /* Ensures it's a block element */
    text-align: center; /* Centers the checkmark inside the circle */
    line-height: 20px; /* Vertically centers the checkmark */
}

  
  
  .pre-comments{
    margin: 0px;
    white-space: pre-wrap;
    font-family: "Poppins", sans-serif;
   
    font-style: normal;
  }
  .comments ::before{
    display: block;
    clear: both;
    content: "";
    position: absolute;
    bottom: -8px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 12px;
    transform: rotate(317deg);
    border-color: #3e353500 #9b969600 #f8f9fa00 var(--bs-blue);
    right: -12px;
  }
  
  
  .profileclass {
    width: 35px;
    border-radius: 100%;
    height: 35px;
}
.postcomment{
    color: #818181 !important;
    font-size: 12px !important;
    font-weight: revert !important;
}
  
.selected {
    background-color: red;
}
.infinite-overflow{
  overflow-x: hidden !important;
}
.minicommentstart {
    justify-content: left;
     }
     .minicommentstart .comments{
       background-color:#f8f9fa;
       color:  rgb(71 68 68);
       /* width: 300px; */
       min-width: 240px;
       max-width: 800px;
     }
     .minicommentstart .comments ::before{
     border-color: #3e353500 #9b969600 #f8f9fa00 #f8f9fa !important; 
     }
     /* .minicommentend {
     justify-content: right;
      position: relative;
      left: 980px;
     } */
     
     .custom-image {
        border: 1px solid #ccc;
        border-radius: 5px;
        margin-bottom: 10px;
      }
      
      .custom-video {
        border: 1px solid #ccc;
        border-radius: 5px;
        margin-bottom: 10px;
        width: 400px;
        height: 400px;
      }
      
      .custom-audio {
        margin-bottom: 10px;
      }
      .video-size{
        height: 75vh; 
        object-fit: cover;
        width: 100%;
      }
      .star-grey{
        color: #6e6c6c;
      font-size: 12px;
      }
      .left-border{
        border-left: 2px solid #d3d3d354;
      }
      .todos-home{
        font-size: 15px;
        color: #4a4a4a !important;
        text-decoration: none;
        font-weight: 300;
      } 
      .comment-margin{
        margin-left: 160px;
      }
      .ministatic{
        width: 80%;
        height: 400px;
        background-color: #f1f1f3;
        border-radius: 5px;
      }
     @media screen and (max-width:576px){
      .home-text{
        display: inline !important;
      }
      .button-containers {
        margin: 6px;
      }
      .button-next{
        font-size: 12px;
        padding: 10px 15px;
      }
     }`, "",{"version":3,"sources":["webpack://./src/Components/comments/MiniComments.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,2BAA2B;AAC/B;AACA;IACI,oCAAoC;IACpC,WAAW;AACf;AACA;;;;;;GAMG;AACH;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;AACA;AACA;2BAC2B;AAC3B,eAAe;IACX,yBAAyB;IACzB,gBAAgB;AACpB;AACA;CACC,wBAAwB;CACxB;AACD;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB,EAAE,8CAA8C;IAClE,yBAAyB,EAAE,uBAAuB;;EAEpD;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,iDAAiD;IACjD,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;;IAEE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;EACA,uBAAuB;EACvB;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,uDAAuD;EACzD;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,WAAW,EAAE,+CAA+C;IAC5D,YAAY,EAAE,+CAA+C;IAC7D,qBAAqB,EAAE,iCAAiC;IACxD,kBAAkB,EAAE,4CAA4C;IAChE,iBAAiB,EAAE,qCAAqC;AAC5D;;;;EAIE;IACE,WAAW;IACX,qBAAqB;IACrB,kCAAkC;;IAElC,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAGlB,yBAAyB;IACzB,0DAA0D;IAC1D,YAAY;EACd;;;EAGA;IACE,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;IACI,qBAAqB;KACpB;KACA;OACE,wBAAwB;OACxB,qBAAqB;OACrB,kBAAkB;OAClB,gBAAgB;OAChB,gBAAgB;KAClB;KACA;KACA,8DAA8D;KAC9D;KACA;;;;QAIG;;KAEH;QACG,sBAAsB;QACtB,kBAAkB;QAClB,mBAAmB;MACrB;;MAEA;QACE,sBAAsB;QACtB,kBAAkB;QAClB,mBAAmB;QACnB,YAAY;QACZ,aAAa;MACf;;MAEA;QACE,mBAAmB;MACrB;MACA;QACE,YAAY;QACZ,iBAAiB;QACjB,WAAW;MACb;MACA;QACE,cAAc;MAChB,eAAe;MACf;MACA;QACE,gCAAgC;MAClC;MACA;QACE,eAAe;QACf,yBAAyB;QACzB,qBAAqB;QACrB,gBAAgB;MAClB;MACA;QACE,kBAAkB;MACpB;MACA;QACE,UAAU;QACV,aAAa;QACb,yBAAyB;QACzB,kBAAkB;MACpB;KACD;MACC;QACE,0BAA0B;MAC5B;MACA;QACE,WAAW;MACb;MACA;QACE,eAAe;QACf,kBAAkB;MACpB;KACD","sourcesContent":[".commentform {\n    border-radius: 13px !important;\n    border: 2px solid #ebebeb !important;\n    overflow: hidden !important;\n}\n.textblue{\n    background-color: #0079ff !important;\n    color: #fff;\n}\n/* .custum-card{\n    position: absolute;\n    width: 145px;\n    height: 100px;\n    transform: translate(1132px, 50px);\n    z-index: 1;\n} */\n.done-top-job-text{\n    font-size: 16px !important;\n    color: #4a4a4a!important;\n}\n.gigclass {\n/* font-size: 11px;\ncolor: #4a4a4a!important; */\nfont-size: 11px;\n    color: #656262 !important;\n    font-weight: 300;\n}\n.text-areamini{\n height: 400px !important; \n }\n.comments {\n    background-color: #0079FF;\n    min-width: 240px;\n    height: auto;\n    max-width: 800px;\n    color: white;\n    padding: 8px;\n    border-radius: 5px;\n    /* word-wrap: break-word; */\n    position: relative; /* Allow long words to wrap to the next line */\n    overflow-wrap: break-word; /* For newer browsers */\n    \n  }\n  .button-containers {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 20px;\n  }\n  \n  .button-next {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 30px;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.3s, transform 0.3s;\n    display: flex;\n    align-items: center;\n  }\n  \n  .prev-button {\n    background-color: #f1a631;\n    color: white;\n  }\n  \n  .next-button {\n    background-color: #0042a6;\n    color: white;\n  }\n  \n  .prev-button:hover,\n  .next-button:hover {\n    background-color: #555;\n    transform: scale(1.1);\n  }\n  \n  .icon {\n    margin: 0 10px;\n  }\n  /* custumcheckbox css */\n  .custom-checkbox-icon {\n    font-size: 24px;\n    color: black;\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease;\n  }\n  \n  .custom-checkbox-icon.checked {\n    background-color: green;\n    color: white;\n    border-radius: 50%;\n    width: 25px; /* Adjust this value according to your design */\n    height: 25px; /* Adjust this value according to your design */\n    display: inline-block; /* Ensures it's a block element */\n    text-align: center; /* Centers the checkmark inside the circle */\n    line-height: 20px; /* Vertically centers the checkmark */\n}\n\n  \n  \n  .pre-comments{\n    margin: 0px;\n    white-space: pre-wrap;\n    font-family: \"Poppins\", sans-serif;\n   \n    font-style: normal;\n  }\n  .comments ::before{\n    display: block;\n    clear: both;\n    content: \"\";\n    position: absolute;\n    bottom: -8px;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 12px;\n    -webkit-transform: rotate(-37deg);\n    -ms-transform: rotate(-37deg);\n    transform: rotate(317deg);\n    border-color: #3e353500 #9b969600 #f8f9fa00 var(--bs-blue);\n    right: -12px;\n  }\n  \n  \n  .profileclass {\n    width: 35px;\n    border-radius: 100%;\n    height: 35px;\n}\n.postcomment{\n    color: #818181 !important;\n    font-size: 12px !important;\n    font-weight: revert !important;\n}\n  \n.selected {\n    background-color: red;\n}\n.infinite-overflow{\n  overflow-x: hidden !important;\n}\n.minicommentstart {\n    justify-content: left;\n     }\n     .minicommentstart .comments{\n       background-color:#f8f9fa;\n       color:  rgb(71 68 68);\n       /* width: 300px; */\n       min-width: 240px;\n       max-width: 800px;\n     }\n     .minicommentstart .comments ::before{\n     border-color: #3e353500 #9b969600 #f8f9fa00 #f8f9fa !important; \n     }\n     /* .minicommentend {\n     justify-content: right;\n      position: relative;\n      left: 980px;\n     } */\n     \n     .custom-image {\n        border: 1px solid #ccc;\n        border-radius: 5px;\n        margin-bottom: 10px;\n      }\n      \n      .custom-video {\n        border: 1px solid #ccc;\n        border-radius: 5px;\n        margin-bottom: 10px;\n        width: 400px;\n        height: 400px;\n      }\n      \n      .custom-audio {\n        margin-bottom: 10px;\n      }\n      .video-size{\n        height: 75vh; \n        object-fit: cover;\n        width: 100%;\n      }\n      .star-grey{\n        color: #6e6c6c;\n      font-size: 12px;\n      }\n      .left-border{\n        border-left: 2px solid #d3d3d354;\n      }\n      .todos-home{\n        font-size: 15px;\n        color: #4a4a4a !important;\n        text-decoration: none;\n        font-weight: 300;\n      } \n      .comment-margin{\n        margin-left: 160px;\n      }\n      .ministatic{\n        width: 80%;\n        height: 400px;\n        background-color: #f1f1f3;\n        border-radius: 5px;\n      }\n     @media screen and (max-width:576px){\n      .home-text{\n        display: inline !important;\n      }\n      .button-containers {\n        margin: 6px;\n      }\n      .button-next{\n        font-size: 12px;\n        padding: 10px 15px;\n      }\n     }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
